import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { take, tap } from "rxjs";

@Injectable()
export class AuthService {

  constructor(
    private readonly http: HttpClient,
  ) { }

  private readonly API_URL = `${environment.API}`;

  login(email: string, password: string) {
    const loginBody = {
      email: email,
      password: password,
    };

    return this.http.post<{accessToken: string, user: Record<string, unknown>}>(`${this.API_URL}/login`, loginBody)
      .pipe(tap(response => this.setSession(response.accessToken, response.user)));
  }

  private setSession(token: string, user: Record<string, unknown>) {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("bearer_token", token);
  }

  getCurrentUser() {
    const user: Record<string, unknown> = JSON.parse(localStorage.getItem("user") ?? "{}");
    return user;
  }

  getToken() {
    const token = localStorage.getItem("bearer_token");
    return token;
  }

  async logout() {
    const email = localStorage.getItem("user_email");
    await this.http.post<{ token: string }>(`${this.API_URL}/logout`, { email: email })
      .pipe(take(1));
    localStorage.removeItem("bearer_token");
    localStorage.removeItem("user");
    localStorage.removeItem("lastReport");
  }

  isLoggedIn() {
    return !!localStorage.getItem("bearer_token");
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  forgotPassword(email: string) {
    return this.http.post(`${this.API_URL}/forgot-password`, { email: email })
      .pipe(take(1));
  }

  resetPassword(email: string, code: string, newPassword: string) {
    return this.http.post(`${this.API_URL}/reset-password`, { email: email, code: code, newPassword: newPassword })
      .pipe(take(1));
  }

  requestNewCode(email: string) {
    return this.http.post(`${this.API_URL}/confirmation-code`, { email: email })
      .pipe(take(1));
  }

  confirmUser(email: string, code: string, newPassword: string) {
    return this.http.post(`${this.API_URL}/confirm-user`, { email: email, code: code, newPassword: newPassword })
      .pipe(take(1));
  }

  getUser(userId: string) {
    return this.http.get<Record<string, unknown>>(`${this.API_URL}/users/${userId}`).pipe(take(1));
  }
}
